exports = module.exports = require("../../node_modules/@vue/cli-service/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".member-type-details label {\n  font-weight: bold;\n}\n.member-type-details__color-preview {\n  height: 32px;\n  width: 64px;\n  vertical-align: middle;\n  display: inline-block;\n}\n", ""]);

// exports
